// extracted by mini-css-extract-plugin
export default {"list":"StoreList__list___PA0N6","listItem":"StoreList__listItem___zW2PQ"};